import { render, staticRenderFns } from "./comp_OfferCard.vue?vue&type=template&id=3faf2ec8&scoped=true&"
import script from "./comp_OfferCard.vue?vue&type=script&lang=js&"
export * from "./comp_OfferCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_OfferCard.vue?vue&type=style&index=0&id=3faf2ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf2ec8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
